<template>
  <transition name="slide-fade" >
    <div  id="academicsHolder" >
      <div class="uk-child-width-1-1" uk-grid>
     <!--   <div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
          <div class="uk-container uk-container-small ">
            <p class="uk-text-center uk-text-lead@l uk-text-large@l">
              New to the country or the area we can help you get settled.
            </p>
          </div>
        </div>-->

        <div class="uk-padding  uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <h1 class=" uk-text-center specHeading">Campus Safety and Security Department</h1>
            <div uk-grid>
              <div class="uk-width-2-3@m">
                <p class="">
                  The Campus Safety and Security Department ensures that student safety and security on campus are
                  priority number one on its agenda. As such, it continues to build capacity in order to provide safety and
                  security services on a 24-hour basis, to mitigate related risks and threats. It ensures that reported
                  security breaches and offences against persons are investigated and the necessary action taken. These
                  services are delivered in collaboration with the Occupational Safety and Health Office (OSHO).
                </p>
                <p class="">
                  The Campus Safety and Security offices are strategically located at the front of the Main Campus, in
                  close proximity to both the Main Gate and Pedestrian Gate, allowing easy access for all to interact –
                  make queries, lodge complaints, give information, etc. – with customer-friendly staff.
                </p>
                  <p class="">Contact may alternatively be made by telephone to the following numbers:</p>
                <ul class="uk-list uk-list-bullet uk-text-small">
                  <li class="uk-text-small">Administrative Office: 876-963-7702, Ext. 7702, 876-963-7703, Ext 7703</li>
                  <li class="uk-text-small">Duty Office: 876-449-9401 (Cell phone)</li>
                  <li class="uk-text-small">Main Gate: 876-963-7704, Ext 7704</li>
                  <li class="uk-text-small">Pedestrian Gate: 876-963-7707, Ext. 7707</li>
                  <li class="uk-text-small">Emailing: lprm@ncu.edu.jm</li>
                </ul>
                <p>
                  For emergencies on campus the number to call is Ext 5555; a Rapid Response Team (RRT), supported by
                  ambulance service where necessary, will be deployed.
                </p>
                <p class="">
                  Elements of security provision such as security personnel posted at all Points of Entry/Exit (POE) and at
                  various offices or services on campus, and patrols are made deliberately obvious. However, layers of
                  surveillance such as CCTV and drone, while not always obvious, provide excellent technological support.
                </p>
                <p class="">
                  Immediate security and safety measures on campus begin with the RULES OF ENTRY AND EXIT, which
                  are posted at all points of entry; encouraging all persons to be security-aware and essentially
                  knowledgeable of the existing code of conduct for entry to and duration of stay on campus:
                </p>
              </div>
              <div class=" uk-width-1-1@s uk-width-1-3@m">
                <div class=" uk-child-width-1-3@s uk-child-width-1-1@l" uk-grid>
                  <div>
                    <img class="uk-border-circle uk-align-center" src="../assets/publicsafety1.jpg" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle uk-align-center" src="../assets/publicsafety2.jpg" width="200" height="200" alt="Border circle">
                  </div>
                  <div>
                    <img class="uk-border-circle uk-align-center" src="../assets/publicsafety3.jpg" width="200" height="200" alt="Border circle">
                  </div>

                </div>
              </div>
              <br>

            </div>
          </div>
        </div>
        <div class="uk-padding uk-background-muted uk-margin-remove-top">
          <div class="uk-container uk-container-small">
            <div class="uk-child-width-1-2@m" uk-grid>
              <div>
                <h3 class="uk-heading-bullet uk-text-left specHeading">Rules of Entrance and Exit </h3>
                <br>
                <ul class="uk-list uk-list-divider ">
                  <li>
                    NCU Employees and Students’ photo Identification Cards are to be
                    presented at the Gates upon entry and prominently displayed on person at
                    all times while on campus.
                  </li>
                  <li>
                    Visitors are to display Visitor’s Passes on their person while on campus.
                  </li>
                  <li>
                    The dress code for students is to be observed as stipulated in the Student
                    Guide. Employees are to dress as per Working Policy, and Visitors are to
                    dress modestly.
                  </li>
                  <li>
                    Visitors shall commit to follow instructions given by the Campus Security
                    and Safety/ Security Officers at the gates, before being allowed access to
                    the campus.
                  </li>
                  <li>
                    Motorists shall wind windows (security booth side) down on entry and exit.
                    Motorists shall dim headlights on approaching gates at night.
                  </li>
                  <li>
                    Visitors, Students and Employees are to park as directed by the Campus
                    Security and Safety Officers/Security Officers and or signage.
                  </li>


                </ul>
              </div>
              <div>
                <h3 class=" uk-text-left specHeading"></h3>
                <br><br>
                <ul class="uk-list uk-list-divider ">

                  <li>
                    Traffic Regulations are in force. Vehicles parked in No Parking or Restricted
                    Areas will be clamped and a fine imposed for releasing same.
                  </li>
                  <li>
                    The University is not liable for loss or damage to personal property or
                    motor vehicles while on the campus.
                  </li>
                  <li>
                    Offensive Weapons, Explosive Devices, Narcotic Substances and Alcoholic
                    Beverages are prohibited.
                  </li>
                  <li>
                    All persons entering or leaving the campus are subject to search.
                  </li>
                  <li>
                    Gate Pass is required for equipment and supplies leaving the campus.
                  </li>
                  <li>No Unauthorized Vending and Begging Allowed.</li>
                  <li>The University’s roadways are private.</li>
                  <li>
                    Unregistered, Unlicensed and Uninsured motorcycles and motor vehicles
                    are prohibited.
                  </li>
                  <li>Taxi Operators are to remain at the Taxi Bay.</li>
                </ul>
              </div>

              <br><br>

            </div>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
    export default {
        name: "publicsafety",
      mounted(){
        window.scrollTo(0, 0);
      },
      metaInfo: {
        // Children can override the title.
        title: 'NCU Public Safety',
        // Result: My Page Title ← My Site
        // If a child changes the title to "My Other Page Title",
        // it will become: My Other Page Title ← My Site
        //titleTemplate: '%s ← My Site',
        // Define meta tags here.
        meta: [
          {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
          {name: 'viewport', content: 'width=device-width, initial-scale=1'},
          {name: 'description', content: 'Public Safety measures at Northern Caribbean University '}
        ]
      }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h3{
      font-size: 1.1em !important;
    }
    h1{
      font-size: 1.3em !important;
    }
    p,li{
      font-size: 0.8em !important;
    }
 img{
   width: 150px;
   height: 150px;
 }

  }
</style>
